// extracted by mini-css-extract-plugin
export default {"_":"Icon____v+iOj"};